<template>
  <a-card :bordered="false">
    <a-row :gutter="24" style="margin-bottom: 2vh;">
      <a-col :md="8" :sm="24" style="margin-bottom: 12px;">
        <a-radio-group defaultValue="b" buttonStyle="solid" @change="onIsReadChange">
          <a-radio-button value="a">全部</a-radio-button>
          <a-radio-button value="b">未读</a-radio-button>
          <a-radio-button value="c">已读</a-radio-button>
        </a-radio-group>
      </a-col>
      <a-col :md="16" :sm="24">
        <a-button-group :style="isMobile() ? {} : { float: 'right' }">
          <a-button @click="handleReadAll">全部已读</a-button>
          <a-button :disabled="disabled" @click="handleRead">标记已读</a-button>
          <a-button type="danger" :disabled="disabled" @click="handleRemove">删除</a-button>
        </a-button-group>
      </a-col>
    </a-row>
    <a-table
      :columns="columns"
      :rowSelection="{ selectedRowKeys: msgIds, onChange: rowSelection }"
      :rowKey="record => record.id"
      :dataSource="page.content"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange">
      <template slot="ant" slot-scope="text, record">
        <router-link :to="{ name: 'MessageDetail', query: { id: encrypt(record.id) } }">{{ record.title }}</router-link>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { convertToPagination, encrypt } from '@/utils/util'
import { pageMessages, setRead, setAllRead, remove } from '@/api/message'
import { mixinDevice } from '@/utils/mixin'

export default {
  mixins: [mixinDevice],

  data () {
    return {
      loading: true,
      disabled: true,
      query: {
        isRead: false,
        prop: '',
        direction: '',
        pageSize: 10,
        pageNumber: 0
      },
      page: {
        content: [],
        empty: false,
        first: true,
        last: true,
        number: 1,
        numberOfElements: 1,
        size: 1,
        sort: {},
        totalElements: 1,
        totalPages: 1
      },
      columns: [
        {
          title: '标题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'ant' }
        },
        {
          title: '时间',
          dataIndex: 'gmtCreate'
        }
      ],
      pagination: {
        current: 1,
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      msgIds: []
    }
  },

  computed: {
  },

  watch: {
    msgIds (val) {
      this.disabled = !(val && val.length > 0)
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    encrypt,

    onIsReadChange (e) {
      if (e.target.value === 'a') {
        this.query.isRead = null
      } else {
        this.query.isRead = e.target.value !== 'b'
      }
      this.fetchData()
    },

    rowSelection (selectedRowKeys) {
      this.msgIds = selectedRowKeys
    },

    fetchData () {
      this.loading = true
      this.msgIds = []
      pageMessages(this.query).then(response => {
        this.page = response.data
        this.pagination = convertToPagination(this.page, this.pagination)
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },

    handleTableChange (pagination, filters, sorter) {
      this.query.pageNumber = pagination.current - 1
      this.query.pageSize = pagination.pageSize
      this.fetchData()
    },

    handleReadAll () {
      setAllRead().then(response => {
        this.$message.success(response.msg)
        this.fetchData()
      }).catch(err => {
        console.log(err)
      })
    },

    handleRead () {
      setRead(this.msgIds).then(response => {
        this.$message.success(response.msg)
        this.fetchData()
      }).catch(err => {
        console.log(err)
      })
    },

    handleRemove () {
      remove(this.msgIds).then(response => {
        this.$message.success(response.msg)
        this.fetchData()
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>

</style>
